import React from 'react';
import Works from '../Home/Works/Works';

const Portfolio = () => {
    return (
        <div style={{ backgroundColor:'#111430', height:'100vh'}}>
            <Works />
        </div>
    );
};

export default Portfolio;